




































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class DisableEmail extends Vue {
  @Prop() onConfirm!: any;
  @Prop() nameEmail!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleConfirm() {
    this.handleClose();
    this.onConfirm();
  }

  get title() {
    return this.$t(`${this.tPrefix}.disable.title`, {
      nameEmail: this.nameEmail
    });
  }

  get description() {
    return this.$t(`${this.tPrefix}.disable.description`, {
      date: new Date().toLocaleDateString()
    });
  }

  get tPrefix() {
    return 'emailAutomation.modals';
  }
}
